"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalSignaling {
    prepare() {
        // Instant ready
        return new Promise(resolve => {
            resolve();
        });
    }
    send(to, data) {
        // Swap offers and answers
        const answerRe = /connection-answer-(\d+)/;
        const offerRe = /connection-offer-(\d+)/;
        const answerMatch = answerRe.exec(to);
        const offerMatch = offerRe.exec(to);
        if (answerMatch && answerMatch[1]) {
            data.id = 'connection-offer-' + answerMatch[1];
        }
        else if (offerMatch && offerMatch[1]) {
            data.id = 'connection-answer-' + offerMatch[1];
        }
        if (this.onIncomingDataCallback) {
            this.onIncomingDataCallback(data);
        }
    }
    bindOnIncomingDataCallback(callback) {
        this.onIncomingDataCallback = callback;
    }
    bindInitiateOfferCallback(callback) {
        this.onInitiateOfferCallback = callback;
    }
    bindOnWebRtcConnectionErrorCallback(callback) {
        this.onWebRtcConnectionErrorCallback = callback;
    }
    getId() {
        return 'does-not-matter';
    }
    initiate(connectionsNum = 1) {
        if (this.onInitiateOfferCallback) {
            for (let i = 1; i <= connectionsNum; i += 1) {
                this.onInitiateOfferCallback('connection-answer-' + i);
            }
        }
    }
    onWebRtcConnectionError(id) {
        if (this.onWebRtcConnectionErrorCallback) {
            this.onWebRtcConnectionErrorCallback(id);
        }
    }
}
exports.LocalSignaling = LocalSignaling;
